import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import './style.css';

const EditorModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }], // Header options
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote', 'link', 'clean'],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
      { align: ['', 'right', 'center', 'justify'] },
    ],
    [''],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const EditorFormats = [
  'header', // Header format (e.g., '1', '2', etc.)
  'size', // Font size (e.g., 'small', 'large', 'huge')
  'bold', // Bold text
  'italic', // Italic text
  'underline', // Underlined text
  'strike', // Strikethrough text
  'blockquote', // Blockquote
  'link', // Link
  'clean', // Clean formatting
  'color', // Text color
  'background', // Background color
  'script', // Subscript and superscript (e.g., 'sub', 'super')
  'align', // Text alignment
  'list', // List format (e.g., 'ordered', 'bullet')
  'indent', // Indentation
  'code-block', // Code block
];

const TextEditor: React.FC<{
  textEditorValue: string;
  setTextEditorValue: (data: string) => void;
  height: string;
}> = ({ textEditorValue = '', setTextEditorValue = data => {}, height }) => {
  return (
    <div
      className={`flex items-center justify-center w-full mb-2 relative ${
        height ? height : 'h-60'
      } editor-container`}
    >
      <ReactQuill
        theme="snow"
        value={textEditorValue}
        onChange={content => setTextEditorValue(content)}
        modules={EditorModules}
        formats={EditorFormats}
        className="h-full w-full"
        id="content"
      />
    </div>
  );
};

export default TextEditor;
